import React from 'react';
import { Outlet, useNavigate, useLocation } from 'react-router-dom';
import { Layout, Menu, Typography, Button, Space, Avatar } from 'antd';
import {
  DashboardOutlined,
  CalendarOutlined,
  TeamOutlined,
  StopOutlined,
  SettingOutlined,
  LogoutOutlined,
  MenuFoldOutlined,
  MenuUnfoldOutlined,
  BarChartOutlined,
  ThunderboltOutlined,
  RobotOutlined,
  ShopOutlined,
} from '@ant-design/icons';
import { useAuth } from '../../contexts/AuthContext';

const { Sider, Header, Content } = Layout;
const { Text } = Typography;

const AdminLayout = () => {
  const [collapsed, setCollapsed] = React.useState(false);
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();

  const menuItems = [
    { key: '/admin', icon: <DashboardOutlined />, label: 'Dashboard' },
    { key: '/admin/planning', icon: <CalendarOutlined />, label: 'Planning' },
    { key: '/admin/teams', icon: <TeamOutlined />, label: 'Équipes' },
    { key: '/admin/depots', icon: <ShopOutlined />, label: 'Dépôts' },
    { key: '/admin/absences', icon: <StopOutlined />, label: 'Absences' },
    { key: '/admin/analytics', icon: <BarChartOutlined />, label: 'Optimisation' },
    { key: '/admin/optimizer', icon: <ThunderboltOutlined />, label: 'Optimiseur' },
    { key: '/admin/chat', icon: <RobotOutlined />, label: 'Assistant IA' },
    { key: '/admin/config', icon: <SettingOutlined />, label: 'Configuration' },
  ];

  const handleLogout = () => {
    logout();
    navigate('/admin/login');
  };

  return (
    <Layout style={{ minHeight: '100vh' }}>
      <Sider
        collapsible
        collapsed={collapsed}
        onCollapse={setCollapsed}
        breakpoint="lg"
        style={{ background: '#001529' }}
      >
        <div style={{
          height: 56, display: 'flex', alignItems: 'center',
          justifyContent: 'center', borderBottom: '1px solid rgba(255,255,255,0.1)',
        }}>
          <CalendarOutlined style={{ color: '#059669', fontSize: 20, marginRight: collapsed ? 0 : 8 }} />
          {!collapsed && (
            <Text strong style={{ color: 'white', fontSize: 14 }}>
              EcoRenov<span style={{ color: '#059669' }}>RDV</span>
            </Text>
          )}
        </div>
        <Menu
          theme="dark"
          mode="inline"
          selectedKeys={[location.pathname]}
          items={menuItems}
          onClick={({ key }) => navigate(key)}
          style={{ borderRight: 0 }}
        />
      </Sider>
      <Layout>
        <Header style={{
          background: 'white',
          padding: '0 24px',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          borderBottom: '1px solid #f0f0f0',
          height: 56,
        }}>
          <Button
            type="text"
            icon={collapsed ? <MenuUnfoldOutlined /> : <MenuFoldOutlined />}
            onClick={() => setCollapsed(!collapsed)}
          />
          <Space>
            <Avatar size="small" style={{ background: '#059669' }}>
              {user?.nom?.[0] || 'A'}
            </Avatar>
            <Text>{user?.nom || 'Admin'}</Text>
            <Button type="text" icon={<LogoutOutlined />} onClick={handleLogout} danger>
              Déconnexion
            </Button>
          </Space>
        </Header>
        <Content style={{ margin: 24, minHeight: 280 }}>
          <Outlet />
        </Content>
      </Layout>
    </Layout>
  );
};

export default AdminLayout;
